import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../buttons/button';
import Icon from '../icon';

import './style.scss';

export default class ActionList extends Component {
  constructor() {
    super();

    this.state = {
      isOpen: false,
    };
  }

  handleClick = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render() {
    const actionListClasses = classNames('uni-actionlist', {
      'uni-actionlist--is-open': this.state.isOpen,
    });

    return (
      <div className={actionListClasses}>
        <Button
          type={this.props.type}
          style="standard"
          size="medium"
          icon="uimore"
          onClick={this.handleClick}
          qaId={this.props.qaId}
        />
        <ul className="uni-actionlist__options">
          {this.props.actions.map((item, key) => {
            const actionItemClasses = classNames('uni-actionlist__option', {
              'uni-actionlist__option--is-destructive': item.isDestructive,
            });

            return (
              <li
                className={actionItemClasses}
                data-qa-id={item.qaId}
                onClick={() => {
                  this.handleClick();
                  item.onClick();
                }}
                key={key}
              >
                {item.icon && <Icon size="medium" type={item.icon} />}
                {item.label}
              </li>
            );
          })}
        </ul>
        <div className="uni-actionlist--outer-region" onClick={this.handleClick} />
      </div>
    );
  }
}

ActionList.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary', 'subtle']),
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
      isDestructive: PropTypes.bool,
      qaId: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
  qaId: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/action-list/index.jsx